export const solutionsState = {
    solutions: [],
    counters: {},
    currentPage: 1,
    lastPage: 1,
    error: '',
    loading: false,
    solutionsStatusList: [],
    removedSolutionIndex: 0,
    removedVersionIndex: 0,
    accessDataForRestore: null,
    currentProject: null,
    versions: [],
    versionsCounts: {},
    currentVersionPage: 0,
    versionsLastPage: 1,
    versionsTotalCount: 0,
    versionsError: '',
    vesionsLoading: false,
    version: {},
    versionLoading: false,
    accessDenied: false,
    IsDefaultSolutionFilters: false,
    copyVersion: null,
    copyVersionStructure: {
        loading: false,
        data: null,
        selected: [],
    },
    copyDest: null,
    sendingCopy: false,
    removingVersion: false,
};
